const defaults = {
  // craco-config
  borderRadiusBase: 8,
  borderRadiusSm: 6,
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Nunito Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', Inter , Tajawal , 'Tajawal' ,
  'Noto Color Emoji'`,
  heightSm: 24,
  heightBase: 32,
  heightLg: 48,
  // other
  siderTheme: 'light',
  paddingBase: 16,
  checkboxBorderRadius: 2,
  formVerticalSpacing: 24,
  formHorizontalSpacing: 20,
  formInputWidth: 340,
  formInputMaxWidth: 400,
  containerBorderRadius: 20,
  formButtonWidth: 160,
  logoHeight: 32,
  logoWithTextHeight: 25,
  breakpoints: {
    xs: 414,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1468,
  },
};

export default defaults;
